<div class="toolbar-content tui-space_horizontal-4">
  <a routerLink="home">
    <tui-svg
      class="logo"
      src="https://res.cloudinary.com/aitarget/image/upload/v1622046860/ai-tech-logo/login-logo-new-svg.svg"
    ></tui-svg>
  </a>
  <div class="first-col">
    <button
      #rlaHome="routerLinkActive"
      [class.active-menu]="rlaHome.isActive"
      (click)="onHomeClick()"
      size="m"
      tuiButton
      type="button"
      appearance="menu-button"
      routerLink="home"
      routerLinkActive
    >
      {{ 'TOOLBAR.HOME' | translate }}
    </button>
    <button
      #rlaOverlays="routerLinkActive"
      [class.active-menu]="rlaOverlays.isActive"
      (click)="onOverlaysClick()"
      data-gtm-id="fb_home_commerce"
      size="m"
      tuiButton
      type="button"
      appearance="menu-button"
      routerLink="overlays"
      routerLinkActive
    >
      {{ 'TOOLBAR.COMMERCE' | translate }}
    </button>
    <button
      #rlaVideos="routerLinkActive"
      [class.active-menu]="rlaVideos.isActive"
      (click)="onVideoClick()"
      size="m"
      tuiButton
      type="button"
      appearance="menu-button"
      routerLink="videos"
      routerLinkActive
    >
      {{ 'TOOLBAR.VIDEOS' | translate }}
    </button>
    <button
      #rlaStatistics="routerLinkActive"
      *ngIf="isStatisticsShown$ | async"
      [class.active-menu]="rlaStatistics.isActive"
      size="m"
      tuiButton
      type="button"
      appearance="menu-button"
      routerLink="statistics"
      routerLinkActive
    >
      {{ 'Statistics' | translate }}
    </button>
    <button
      *ngIf="isPricingShown$ | async"
      (click)="openPricingModal()"
      size="m"
      tuiButton
      type="button"
      appearance="menu-button"
    >
      {{ 'Pricing' | translate }}
    </button>
  </div>
  <div class="second-col">
    <tui-hosted-dropdown class="desktop-view" [content]="toolsDropdown">
      <button
        [iconRight]="arrow"
        tuiButton
        type="button"
        appearance="menu-button"
        icon="https://res.cloudinary.com/aitarget/image/upload/v1616492440/platforms/facebook.svg"
        tuiTextfieldSize="s"
      >
        {{ 'Facebook' | translate }}
      </button>
    </tui-hosted-dropdown>

    <ng-template #toolsDropdown>
      <tui-data-list>
        <button
          *ngFor="let item of toolsDropdownData"
          (click)="item.command()"
          tuiOption
          size="m"
          role="aria-checked"
        >
          <div class="menu-list-button-content">
            <tui-svg class="mr-8" [src]="item.icon"></tui-svg>
            <span class="tui-space_right-4">{{ item.name }}</span>
            <tui-badge *ngIf="item.comingSoon" status="warning" value="Coming soon"></tui-badge>
          </div>
        </button>
      </tui-data-list>
    </ng-template>

    <ng-container *ngIf="user$ | async as user">
      <tui-hosted-dropdown
        class="desktop-view"
        #accountDropdown
        [(open)]="userDropdownOpenStatus"
        [content]="userDropdown"
      >
        <button
          [icon]="userIcon"
          [iconRight]="arrow"
          tuiButton
          type="button"
          appearance="menu-button"
          tuiTextfieldSize="s"
        >
          {{
            user?.impersonated ? 'Impersonation: ' + user?.username : user?.email || user?.username
          }}
        </button>
      </tui-hosted-dropdown>
      <ng-template #userDropdown>
        <ng-container *tuiLet="clientsList$ | async as clientsList">
          <div class="tui-space_top-4 tui-space_horizontal-4" *ngIf="clientsList.length > 1">
            <span class="ait-font-main-color tui-space_right-2">{{
              'Current client:' | translate
            }}</span>
            <a [pseudo]="true" (click)="authService.changeClient()" tuiLink>{{
              (client$ | async)?.name || ''
            }}</a>
          </div>
          <tui-data-list>
            <ng-container *ngFor="let item of userDropdownData">
              <button
                *ngIf="!(item.filterable && clientsList.length <= 1)"
                (click)="accountDropdown.updateOpen(false); item.command()"
                tuiOption
                size="m"
              >
                <div class="menu-list-button-content">
                  <tui-svg class="icon tui-space_right-2" [src]="item.icon"></tui-svg>
                  <span>{{ item.name | async }}</span>
                </div>
              </button>
            </ng-container>
          </tui-data-list>
          <div class="tui-space_bottom-4 tui-space_horizontal-4">
            <label *tuiLet="isNightTheme$ | async as isNightTheme">
              <tui-toggle
                class="special-toggle"
                [ngModel]="isNightTheme"
                (ngModelChange)="onThemeChanged($event)"
                appThemeNightToggle
              >
              </tui-toggle>
              <span class="tui-space_left-2 menu-list-text">{{ themeToggleLabel$ | async }}</span>
            </label>
          </div>
          <div class="tui-space_bottom-4 tui-space_horizontal-4">
            <label *ngIf="isLangChangeShown$ | async">
              <tui-toggle
                class="special-toggle"
                [ngModel]="!localeService.isEngLocale()"
                (ngModelChange)="onLangChanged()"
                appLocaleToggle
              >
              </tui-toggle>
              <span class="tui-space_left-2 menu-list-text">
                {{ (localeService.isEngLocale() ? 'TOOLBAR.EN' : 'TOOLBAR.RU') | translate }}
              </span>
            </label>
          </div>
        </ng-container>
      </ng-template>
      <ng-template #userIcon>
        <div class="account-image" [class.account-image--impersonation]="user?.impersonated">
          <img *ngIf="!user" [src]="user?.picture || 'assets/menu/empty-user.svg'" alt="" />
          <p class="account-image__name" *ngIf="user">{{ user?.username?.charAt(0) }}</p>
        </div>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="user$ | async as user">
      <button
        class="tablet-view"
        (click)="toggleSidebar(true)"
        (tuiActiveZoneChange)="toggleSidebar($event)"
        tuiIconButton
        appearance="menu-button"
        icon="tuiIconMenuLarge"
        type="button"
      >
        <div *tuiSidebar="isSidebarOpen; direction: 'right'">
          <tui-accordion [rounded]="false">
            <tui-accordion-item size="s" borders="top-bottom">
              <div class="menu-list-button-content">
                <tui-svg
                  class="tui-space_right-2"
                  src="https://res.cloudinary.com/aitarget/image/upload/v1616492440/platforms/facebook.svg"
                ></tui-svg>
                <span>Facebook</span>
              </div>
              <ng-template tuiAccordionItemContent>
                <tui-data-list>
                  <button
                    *ngFor="let item of toolsDropdownData"
                    (click)="item.command()"
                    tuiOption
                    size="m"
                    role="aria-checked"
                  >
                    <div class="menu-list-button-content">
                      <tui-svg class="mr-8" [src]="item.icon"></tui-svg>
                      <span class="tui-space_right-4">{{ item.name }}</span>
                      <tui-badge
                        *ngIf="item.comingSoon"
                        status="warning"
                        value="Coming soon"
                      ></tui-badge>
                    </div>
                  </button>
                </tui-data-list>
              </ng-template>
            </tui-accordion-item>
            <tui-accordion-item size="s" borders="top-bottom">
              <div class="sidebar-user-wrapper">
                <div
                  class="account-image sidebar-user-icon mr-8"
                  [class.account-image--impersonation]="user?.impersonated"
                >
                  <img *ngIf="!user" [src]="user?.picture || 'assets/menu/empty-user.svg'" alt="" />
                  <p class="account-image__name" *ngIf="user">{{ user?.username?.charAt(0) }}</p>
                </div>
                <span class="sidebar-user-text">{{
                  user?.impersonated
                    ? 'Impersonation: ' + user?.username
                    : user?.email || user?.username
                }}</span>
              </div>
              <ng-template tuiAccordionItemContent>
                <ng-container *tuiLet="clientsList$ | async as clientsList">
                  <div
                    class="ait-font-text-m tui-space_vertical-1 tui-space_horizontal-4"
                    *ngIf="clientsList.length > 1"
                  >
                    <span class="tui-space_right-2">{{ 'Current client:' | translate }}</span>
                    <a [pseudo]="true" (click)="authService.changeClient()" tuiLink>{{
                      (client$ | async)?.name || ''
                    }}</a>
                  </div>
                  <tui-data-list>
                    <ng-container *ngFor="let item of userDropdownData">
                      <button
                        *ngIf="!(item.filterable && clientsList.length <= 1)"
                        (click)="item.command(); toggleSidebar(false)"
                        tuiOption
                        size="m"
                        role="aria-checked"
                      >
                        <div class="menu-list-button-content">
                          <tui-svg class="icon tui-space_right-2" [src]="item.icon"></tui-svg>
                          <span>{{ item.name | async }}</span>
                        </div>
                      </button>
                    </ng-container>
                  </tui-data-list>
                  <div class="tui-space_vertical-1 tui-space_horizontal-4">
                    <label *tuiLet="isNightTheme$ | async as isNightTheme">
                      <tui-toggle
                        class="theme-toggle"
                        [ngModel]="isNightTheme"
                        (ngModelChange)="onThemeChanged($event)"
                        appThemeNightToggle
                      >
                      </tui-toggle>
                      <span class="tui-space_left-2 menu-list-text">{{
                        themeToggleLabel$ | async
                      }}</span>
                    </label>
                  </div>
                  <div class="tui-space_top-4 tui-space_horizontal-4">
                    <label *ngIf="isLangChangeShown$ | async">
                      <tui-toggle
                        class="special-toggle"
                        [ngModel]="!localeService.isEngLocale()"
                        (ngModelChange)="onLangChanged()"
                        appLocaleToggle
                      >
                      </tui-toggle>
                      <span class="tui-space_left-2 menu-list-text">
                        {{
                          (localeService.isEngLocale() ? 'TOOLBAR.EN' : 'TOOLBAR.RU') | translate
                        }}
                      </span>
                    </label>
                  </div>
                </ng-container>
              </ng-template>
            </tui-accordion-item>
          </tui-accordion>
        </div>
      </button>
    </ng-container>

    <button
      id="seventh-shepherd-element"
      *ngIf="isHelpIconShown()"
      [disabled]="isHelpIconDisabled()"
      (click)="startTour()"
      tuiIconButton
      icon="tuiIconHelpCircleLarge"
      appearance="menu-button"
    ></button>
  </div>
</div>
